import React from 'react'
import Chart from 'react-apexcharts'

const RateRadialChart = React.memo(({ rate, animationsEnabled, label, getColor, ...props }) => {
    const defaultColor = '#212121'

    return (
      <div className={props.className}>
          <Chart
            options={{
                chart: {
                    type: 'radialBar',
                    animations: {
                        enabled: animationsEnabled ?? false,
                        dynamicAnimation: {enabled: false}
                    },
                },
                colors: [getColor ? getColor(rate) : defaultColor],
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            strokeWidth: '97%',
                        },
                        hollow: {
                            size: '80%',
                        },
                        dataLabels: {
                            name: {
                                show: true,
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#333',
                                offsetY: 15,
                            },
                            value: {
                                fontSize: '26px',
                                color: getColor ? getColor(rate) : defaultColor,
                                offsetY: -30,
                                formatter: function (val) {
                                    return val + '%'
                                },
                            },
                        },
                    },
                },
                labels: [label ? label : ''],
            }}
            series={[rate]}
            type="radialBar"
            height={200}
          />
      </div>
    )
})

export { RateRadialChart }
